import { render, staticRenderFns } from "./component.vue?vue&type=template&id=1165db36&lang=pug"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports